module.exports = __webpack_public_path__ + "img/compass.4e3a0b08.png";